import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Utilities } from '@app/core/utils/utilities';
import { HomeLandingPageComponent } from '@app/pages/home/home-landing-page/home-landing-page.component';
import { environment } from '@environments/environment';
import { QuickSearchComponent } from '../quick-search/quick-search.component';
import { ImageUrls } from '@app/shared/constants/image-urls-const';

@Component({
    selector: 'app-header',
    imports: [CommonModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  dialog = inject(MatDialog);
  imageConstants = inject(ImageUrls);
  env = environment;
  userDetails = signal<any>({});
  userLogoDetail = signal('');
  userMenuFlag = signal(false);
  userProfilePopup: boolean = false;
  institutionName = signal<any>('');
  institutionDetails = signal<any>(null);
  institutionStatus = signal<any>('');

  constructor(public util: Utilities, private router: Router) {
    this.fetchingUserAndInstDetails();
  }

  hideShowTopNavMenu() {
    this.userMenuFlag.update(v => !v);
  }

  manageAnotherInstitution(from?: string) {
    this.userMenuFlag.set(false);
    if (from !== "subscribe") {
      this.util.isDialogOpen$.set(true)
      const dialogRef = this.dialog.open(HomeLandingPageComponent, {
        width: '610px',
        panelClass: 'institution_selection'
      });
      dialogRef.afterClosed().subscribe(() => {
        this.util.isDialogOpen$.set(false);
        this.userMenuFlag.set(false);
      })
    }
  }

  fetchingUserAndInstDetails() {
    effect(() => {
      if (this.util.currentUserSession() != '' && Object.keys(this.util.currentUserSession()).length != 0) {
        const details = environment.authDisable ? this.util.currentUserSession()?.getIdToken()?.decodePayload() : this.util.currentUserSession()?.tokens?.idToken?.payload;
        this.userDetails.set(details);
        if (details)
          this.userLogoDetail.set(details.given_name?.substring(0, 1).toUpperCase() + details.family_name?.substring(0, 1).toUpperCase());
      }
    })
    this.util.getInstituionDetails();
    effect(() => {
      const instDetails = this.util.institutionDetails();
      this.institutionDetails.set(instDetails);
      if (instDetails) {
        this.institutionName.set(JSON.parse(instDetails).institutionName);
        this.institutionStatus.set(JSON.parse(instDetails).status);
      }
      else {
        this.institutionName.set('');
        this.institutionStatus.set('');
        this.manageAnotherInstitution("subscribe");
      }
    });
  }

  get userData() {
    return (this.util.userDetails$() || '');
  }

  redirectToInstListPage() {
    this.userMenuFlag.set(false);
    this.router.navigate(['/manage-institution']);
  }

  openQuickSearchPopup() {
    this.util.isDialogOpen$.set(true);
    const dialogRef = this.dialog.open(QuickSearchComponent, {
      width: '610px',
      panelClass: 'quick_search_popup'
    });
    dialogRef.afterClosed().subscribe(() => {
      this.util.isDialogOpen$.set(false);
    })
  }
}
